import { InjectionToken } from '@angular/core';

/** Where a "ping this address" link should navigate to, plus the query params to carry. */
export interface PingRouteTarget {
    link: unknown[];
    queryParams: Record<string, string | number>;
}

/**
 * Resolves the ping page's route for the current app.
 *
 * The two builds put the page in different places — the on-device dashboard at
 * /tools/ping, the cloud portal at /device/:deviceId/ping — so each app provides its own
 * factory and shared components stay agnostic.
 *
 * @param host the address to prefill
 * @param deviceId which device should run the test; cloud pages that list several devices
 *                 pass the row's id, otherwise the current device context is used
 * @returns the navigation target, or null when no ping page can be reached
 */
export type PingRouteFactory = (host: string, deviceId?: string) => PingRouteTarget | null;

export const PING_ROUTE = new InjectionToken<PingRouteFactory>('PING_ROUTE');
